var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-block"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/busImage/comp_logo.png")}}),_c('div',{staticClass:"footer"},[_vm._v("—— 技术支持：400-073-0608 | 北京第玖元素科技有限公司 ——")]),_c('div',{staticClass:"main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }